<template>
  <div style="display: flex;">
    <ValidationProvider
    v-slot="{ errors }"
    :rules="{dateFromIsValid: toTime}"
    style="width:111.28px"
    >
      <TimeInput
        v-model="fromTime"
        style="padding-right: 1rem; margin-bottom: 0.5rem;"
        :label="$t('FechaDesde')"
        :class="errors[0] ? 'from-input': ''"
        :disabled="disabled"
      ></TimeInput>
    </ValidationProvider>

    <ValidationProvider
        :rules="{dateToIsValid: fromTime}"
        v-slot="{ errors }"
        style="width:111.28px"
      >
      <TimeInput
        v-model="toTime"
        style="margin-bottom: 0.5rem;"
        :label="$t('FechaHasta')"
        :class="errors[0] ? 'to-input': ''"
        :disabled="disabled"
      ></TimeInput>
    </ValidationProvider>
  </div>
</template>
<script>
import TimeInput from '../time-input/TimeInput.vue';
export default {
  components: {
    TimeInput,
  },

  name: 'TimeRangeInput',

  props: {
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      require: false,
      default: false
    }
  },

  data () {
    return {
      fromTime: this.value.fromTime ? this.value.fromTime : '00:00',
      toTime: this.value.toTime ? this.value.toTime : '23:59',
    };
  },

  watch: {
    fromTime (fromTime) {
      this.fromTime = fromTime;
      this.$emit('input', { fromTime: this.fromTime, toTime: this.toTime });
    },
    toTime (toTime) {
      this.toTime = toTime;
      this.$emit('input', { fromTime: this.fromTime, toTime: this.toTime });
    },
  },
};
</script>
<style>
  .from-input .vs-con-input .vs-inputx {
    border: 1px solid rgb(234 84 85 / 100%)!important;

  }
  .to-input .vs-con-input .vs-inputx {
    border: 1px solid rgb(234 84 85 / 100%)!important;
  }
</style>
